/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index';
let exports = {};

// ====================== 转岗单管理 ======================

exports.getStaffTansPosFormList = function (data, callback) {// 获取 - 转岗单列表
    api.post('/tans/pos/form/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getStaffTansPosFormInfo = function (params, callback) {// 获取 - 转岗单信息
    api.get('/tans/pos/form/detail/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.doAuditStaffTansPosForm = function (data, callback) {// 审核 - 转岗单
    api.post('/tans/pos/form/audit/do')
    .data(data)
    .done(callback)
    .go();
};
//
// ========================== 人员转岗 ==========================

exports.saveStaffTansPosForm = function (data, callback) { // 人员转岗单-新增
    api.post('/tans/pos/form/save/do')
        .data(data)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/tansPos.js
// module id = 154
// module chunks = 1